import { render } from "./TemperatureReport.vue?vue&type=template&id=1c65cfcc"
import script from "./TemperatureReport.vue?vue&type=script&lang=js"
export * from "./TemperatureReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__